export default "__VITE_ASSET__B$cLbnd0__"